"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Curator = void 0;
const Tags_1 = require("../../cards/Tags");
const IAward_1 = require("../IAward");
class Curator {
    constructor() {
        this.name = 'Curator';
        this.description = 'Have the most played tags of any one type';
    }
    getScore(player) {
        const validTags = [Tags_1.Tags.ANIMAL, Tags_1.Tags.BUILDING, Tags_1.Tags.CITY, Tags_1.Tags.EARTH, Tags_1.Tags.ENERGY, Tags_1.Tags.JOVIAN, Tags_1.Tags.MICROBE, Tags_1.Tags.MOON, Tags_1.Tags.PLANT, Tags_1.Tags.SCIENCE, Tags_1.Tags.SPACE, Tags_1.Tags.VENUS];
        let score = 0;
        validTags.forEach((tag) => {
            const tagCount = player.getTagCount(tag, 'award');
            if (tagCount > score)
                score = tagCount;
        });
        return score + IAward_1.getAdditionalScore(player);
    }
}
exports.Curator = Curator;
//# sourceMappingURL=Curator.js.map